import {
  Component,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  AfterViewInit,
  AfterContentChecked,
  Input,
  Optional,
  EventEmitter,
  Output,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { JoyrideService } from 'ngx-joyride';

import { format } from 'support';
import { JSONStringify } from 'app/SupportOps';

import { MealPlanDay } from 'app/@core/interfaces/common/CalorieFriend/plan-day';
import { MealPlanData, ProgramTemplateData } from 'app/@core/interfaces/common/CalorieFriend/plan';
import { PatientData } from 'app/@core/interfaces/common/CalorieFriend/patients';
import { UsersService } from 'app/@core/backend/common/services/users.service';
import {
  TutorialData,
  TutorialIDs,
} from 'app/@core/interfaces/common/CalorieFriend/tutorial';
import { User } from 'app/@core/interfaces/common/users';
import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import { SmartEditComponent } from 'app/@components/smart-edit/smart-edit.component';

import { PlanDataService } from './PlanService';
import { MealPlanDefComponentBase } from './plan-def-base.component';

/**
 * Component to edit plan data on the 'Edit Template' page.
 * Inherits from the PlanDefComponentBase component.
 */
@Component({
  selector: 'ngx-plan-def',
  templateUrl: './edit-plan-def.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MealPlanDefComponent
  extends MealPlanDefComponentBase
  implements OnInit {
  constructor(
    @Optional() protected PlanDefDialogRef: NbDialogRef<any>,
    private PlanDefRoute: ActivatedRoute,
    private PlanDefLocation: Location,
    private PlanDefToasterService: NbToastrService,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    PlanDefPlanService: MealPlanData,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    patientsService: PatientData,
    programTemplateService: ProgramTemplateData,
  ) {
    super(
      PlanDefRoute,
      PlanDefFormBuilder,
      PlanDefDialogService,
      PlanDefPlanService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      patientsService,
      programTemplateService,
    );

    this.ref = PlanDefDialogRef;

    const templateData = this.PlanDefRoute.snapshot.data.templateData;
    if (templateData && templateData.template) {
      this.EditingTemplate = true;
      this.ThePlan = templateData.template.thePlan;
      this.TheTemplateID = templateData.template.id;
      this.TheTemplateIsPublic = templateData.template.isPublic;
      this.templateUserID = templateData.template.userID;
      this.ThePlan.name = templateData.template.name;
      this.ThePlan.description = templateData.template.description;
      this.TheTemplateName = templateData.template.name;
      this.TheTemplateDescription = templateData.template.description;
    }
  }


  onSavePlan(): void {
    super.SavePlan();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.PatientShortHandName = "Templates";

    if (!this.ThePlan && !this.ThePlan.days?.length) {
      this.NewDay();
    }
  }

  ProblemSavingTemplate = 'Problem updating template';
  TemplateUpdated = 'Template Updated';

  /**
   * Event handler of Success event of Updating a template.
   */
  handleSuccessResponse() {
    this.PlanDefToasterService.success('', `${this.TemplateUpdated}!`);
  }

  /**
   * Event handler of Fail event of Updating a template.
   */
  handleWrongResponse(data: any) {
    this.PlanDefToasterService.danger('', this.ProblemSavingTemplate);
  }

  /**
   * Method to close the container dialog if it is opened in pop up dialog
   * or navigates back to the PatientSheetView page
   */
  Back() {
    this.PlanDefLocation.back();
  }
}

/**
 * Component for the Edit Plan page.
 * Inherits from the PlanDefComponentBase component.
 */
@Component({
  selector: 'ngx-plan-def-edit',
  templateUrl: './edit-plan-def.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditMealPlanDefComponent
  extends MealPlanDefComponentBase
  implements AfterContentChecked, OnInit {
  constructor(
    protected PlanDefDialogRef: NbDialogService,
    private PlanDefCdRef: ChangeDetectorRef,
    route: ActivatedRoute,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    planService: MealPlanData,
    PlanDefToasterService: NbToastrService,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    planDataService: PlanDataService,
    PatientDataService: PatientData,
    programTemplate: ProgramTemplateData,
  ) {
    super(
      route,
      PlanDefFormBuilder,
      PlanDefDialogService,
      planService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      PatientDataService,
      programTemplate,
    );

    this.ref = PlanDefDialogRef;
    this.ThePlan = planDataService.thePlan;
  }

  ngAfterContentChecked() {
    this.PlanDefCdRef.detectChanges();
  }

  /**
   * Initializes the component.
   */
  ngOnInit(): void {
    this.InitPlanDefForm();

    /*if (!this.ThePlan) {
      const retrievedPlan = localStorage.getItem('ThePlan');
      this.ThePlan = JSON.parse(retrievedPlan);
      this.init();
      return;
    }*/

    // get the plan by the id from the query
    const id = this.route.snapshot.paramMap.get('planId');
    this.planService.get(+id).subscribe((data) => {
      this.ThePlan = data;
      this.PlanID = data.id;
      this.PatientID = data.patientID;
      this.init();
    });





  }

  private init(): void {
    super.ngOnInit();

    this.loadPatientData(this.ThePlan.patientID);

    window.addEventListener('beforeunload', () => {
      // this control works on data loaded via data service
      // strategy -- need to set the data so is caught
      // when page reloads
      if (this.ThePlan.id != null && this.ThePlan !== undefined) {
        const Plan = this.ThePlan;
        const ThePlanString = JSONStringify(Plan);
        localStorage.setItem('ThePlan', ThePlanString);
      }
    });
  }

  onSavePlan() {
    this.SavePlan();
  }
}

/**
 * Component for the Add Plan page.
 */
@Component({
  selector: 'app-plan-add',
  templateUrl: './edit-plan-def.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddMealPlanDefComponent
  extends MealPlanDefComponentBase
  implements OnInit {
  constructor(
    private PlanDefRoute: ActivatedRoute,
    protected PlanDefDialogRef: NbDialogService,
    public joyrideService: JoyrideService,
    private tutorialService: TutorialData,
    PlanDefFormBuilder: FormBuilder,
    PlanDefDialogService: NbDialogService,
    PlanDefPlanService: MealPlanData,
    PlanDefToasterService: NbToastrService,
    PlanDefUsersService: UsersService,
    PlanDefRouter: Router,
    planDataService: PlanDataService,
    PatientDataService: PatientData,
    programTemplate: ProgramTemplateData,
  ) {
    super(
      PlanDefRoute,
      PlanDefFormBuilder,
      PlanDefDialogService,
      PlanDefPlanService,
      PlanDefToasterService,
      PlanDefUsersService,
      PlanDefRouter,
      PatientDataService,
      programTemplate,
    );

    this.ref = PlanDefDialogRef;
    this.ThePlan = null;
  }

  currentUser: User = null;

  ngOnInit(): void {
    super.ngOnInit();
    this.NewDay();

    this.currentUserSubject.subscribe((user) => {
      if (user == null) return;

      this.currentUser = user;

      const isFromTutorial =
        this.PlanDefRoute.snapshot.url.length > 2
          ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
          'fromtutorial'
          : false;

      const tutorialStates = JSON.parse(user.tutorialStates ?? '{}');
      const steps = [];

      // check the tutorial step 5 - New Plan
      if (!tutorialStates[TutorialIDs.LoadFromTemplate] && isFromTutorial) {
        this.inTutorial = true;

        steps.push(TutorialIDs.LoadFromTemplate);

        setTimeout(() => {
          this.joyrideService
            .startTour(
              {
                steps: steps,
                showPrevButton: false,
                showCounter: true,
              } // Your steps order
            )
            .subscribe((step) => {
              this.inTutorial = step.name === TutorialIDs.LoadFromTemplate;
            });
        }, 1000);
      }
    });
  }

  onSavePlan() {
    this.joyrideService.closeTour();

    this.SavePlan();

    const isFromTutorial =
      this.PlanDefRoute.snapshot.url.length > 2
        ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
        'fromtutorial'
        : false;

    if (isFromTutorial) {
      this.tutorialService.save(TutorialIDs.FinalStep).subscribe(() => { });
    }

    this.inFinalTutorial = false;
  }

  SelectTemplate() {
    this.inTutorial = false;

    const isFromTutorial =
      this.PlanDefRoute.snapshot.url.length > 2
        ? this.PlanDefRoute.snapshot.url[2].toString().toLowerCase() ===
        'fromtutorial'
        : false;

    super.SelectTemplate(isFromTutorial, this.currentUser);

    // save tutorial position
    this.tutorialService.save(TutorialIDs.LoadFromTemplate).subscribe(() => { });

    this.joyrideService.closeTour();

    this.selectTemplateSubject.subscribe((plan) => {
      if (plan) {
        const tutorialStates = JSON.parse(
          this.currentUser.tutorialStates ?? '{}'
        );

        // final tutorial step
        if (!tutorialStates[TutorialIDs.FinalStep] && isFromTutorial) {
          const steps = [TutorialIDs.FinalStep];

          this.inFinalTutorial = true;

          setTimeout(() => {
            this.joyrideService
              .startTour(
                {
                  steps: steps,
                  showPrevButton: false,
                  showCounter: false,
                } // Your steps order
              )
              .subscribe((step) => {
                this.inFinalTutorial = step.name === TutorialIDs.FinalStep;
              });
          }, 1000);
        }
      }
    });
  }
}

/**
 * Component for Plan View page.
 */
@Component({
  selector: 'app-meal-plan-view',
  templateUrl: './edit-plan-def.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MealPlanViewComponent
  extends MealPlanDefComponentBase
  implements OnInit {
  protected readonly PlanViewUnsubscribe$ = new Subject<void>();
  constructor(
    private PlanViewRoute: ActivatedRoute,
    private PlanViewPatientsService: PatientData,
    private PlanViewUsersService: UsersService,
    PlanViewFormBuilder: FormBuilder,
    PlanViewDialogService: NbDialogService,
    PlanViewPlanService: MealPlanData,
    PlanViewToasterService: NbToastrService,
    PlanViewRouter: Router,
    PatientDataService: PatientData,
    programTemplate: ProgramTemplateData,
  ) {
    super(
      PlanViewRoute,
      PlanViewFormBuilder,
      PlanViewDialogService,
      PlanViewPlanService,
      PlanViewToasterService,
      PlanViewUsersService,
      PlanViewRouter,
      PatientDataService,
      programTemplate,
    );
    this.PlanView = true;
    this.ref = null;

    this.PlanViewRoute.queryParams.subscribe((params) => {
      this.PlanID = params['planID'];
    });
  }


  onSavePlan(): void {
    super.SavePlan();
  }

  /**
   * Initializes the component.
   * Based on the settings of the current user and View type, initializes the view settings for elements.
   */
  ngOnInit(): void {
    super.ngOnInit();

    this.PatientShortHandName = "Templates";

    const loadUser = this.PlanViewUsersService.getCurrentUser();
    loadUser.subscribe((user) => {
      if (user) {
        this.ShowEmailSubmit = true;
        this.HidePatientInfo = false;
      } else {
        this.ShowEmailSubmit = false;
        this.HidePatientInfo = true;
      }
    });
    console.log("Plandef", this.PatientID);
    if (
      (this.PatientID !== null && this.PatientID !== undefined) ||
      this.NotificationToken != null
    )
      this.PlanViewPatientsService.get(this.PatientID, this.NotificationToken)
        .pipe(takeUntil(this.PlanViewUnsubscribe$))
        .subscribe((patient) => {
          this.PatientName = format(
            "{0} {1}'s View",
            patient.firstName,
            patient.lastName
          );
        });

    if (
      this.NotificationToken != null &&
      this.NotificationToken !== undefined
    ) {
      // manually hide components of view --
      let Elements = document.getElementsByClassName('menu-sidebar');
      if (Elements != null && Elements !== undefined && Elements.length > 0) {
        const Sidebar: any = Elements[0];
        Sidebar.style.visibility = 'hidden';
        Sidebar.style.width = '0px';
      }

      Elements = document.getElementsByClassName('header-container');
      if (Elements != null && Elements !== undefined && Elements.length > 0) {
        const container: any = Elements[0];
        const Header = container.parentElement.parentElement.parentElement;
        Header.style.visibility = 'hidden';
        Header.style.height = '0px';
      }

      Elements = document.getElementsByClassName('layout-container');
      if (Elements != null && Elements !== undefined && Elements.length > 0) {
        const container: any = Elements[0];
        container.style.paddingTop = '0px';
      }
    }
  }
}

/**
 * Component for Plan's Report View page.
 */
@Component({
  selector: 'app-meal-plan-report-view',
  templateUrl: './plan-def-report.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportMealPlanViewComponent
  extends MealPlanDefComponentBase
  implements OnInit, AfterViewInit {
  protected readonly PlanViewUnsubscribe$ = new Subject<void>();
  @ViewChild('ReportContent') ReportContent: ElementRef;

  constructor(
    PlanViewRoute: ActivatedRoute,
    PlanViewFormBuilder: FormBuilder,
    PlanViewDialogService: NbDialogService,
    PlanViewPlanService: MealPlanData,
    PlanViewToasterService: NbToastrService,
    PlanViewUsersService: UsersService,
    PlanViewRouter: Router,
    PatientDataService: PatientData,
    programTemplate: ProgramTemplateData,
  ) {
    super(
      PlanViewRoute,
      PlanViewFormBuilder,
      PlanViewDialogService,
      PlanViewPlanService,
      PlanViewToasterService,
      PlanViewUsersService,
      PlanViewRouter,
      PatientDataService,
      programTemplate,
    );
    this.PlanView = true;
    this.ref = null;
  }

  ngOnInit(): void {
    this.loadData = false;
    super.ngOnInit();
  }

  /**
   * Generates the PDF of the plan.
   * @param Plan Plan object
   */
  PrepareReport(Plan) {
    if (this.ThePlan.id !== Plan.id) {
      this.DaySource = null;
      this.TheDays = null;
      this.SelectedPlan(Plan);
    } else {
      this.GeneratePDF(this.ReportContent.nativeElement.innerHTML);
    }
  }

  ngAfterViewInit() { }

  private GeneratePDF(HTMLContent) { }
}

/**
 * Component for Plan Day's header label.
 */
@Component({
  selector: 'app-plan-day-label',
  templateUrl: './plan-day-label.component.html',
  styleUrls: ['./plan-def.component.scss', '../../global.component.scss'],
})
export class PlanDayLabelComponent extends BaseComponentCanDeactivate {
  /** PlanDayLabel ctor */

  @Input('Day') Day: MealPlanDay;
  @Input('readonly') readonly: boolean = false;

  @Output() customfocusout: EventEmitter<void> = new EventEmitter();

  @ViewChild('DayNameEdit') DayNameEdit: SmartEditComponent;

  TheDayLabel = $localize`:@@Day:Day`;

  constructor(
    dialogService: NbDialogService,
    private cdRef: ChangeDetectorRef
  ) {
    super(dialogService);
  }

  onCusomFocusout() {
    this.customfocusout.emit();
  }

  /**
   * Keyup event handler of the label input.
   * @param $event Event object
   */
  onKeyup($event) {
    if (this.Day != null && this.Day !== undefined) {
      this.Day.name = $event.target.value;
      this.isDirty = true;
    }
  }

  GetDayLabel(CurrentLabel: string, ThisThis) {
    return format(
      '{0} {1} ({2})',
      ThisThis.TheDayLabel,
      ThisThis.Day.order,
      ThisThis.Day.name
    );
  }

  public UpdateLabel() {
    this.DayNameEdit.UpdateSecondValue();
    this.cdRef.detectChanges();
  }
}
